export const BACKGROUND_LOADING_COLORS = {
  silverForDesktop: "silver",
  darkGreyForMobileLightText: "darkGrey"
};
